<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="empty" *ngIf="links && !links.length">EMPTY LARGE LINK LIST</div>
  <ng-container *ngFor="let link of links">
    <app-link-list-item
      [image]="link.image?.filename"
      imageStyle="round"
      [title]="link.title"
      [description]="link.subTitle"
      [link]="calcHref(link)"
      [appStoryblok]="link._editable"
      *ngIf="isInternalLink(link)"
    >
    </app-link-list-item>

    <app-link-list-item
      [image]="link.image?.filename"
      imageStyle="round"
      [title]="link.title"
      [description]="link.subTitle"
      [externalLink]="calcHref(link)"
      [appStoryblok]="link._editable"
      *ngIf="!isInternalLink(link)"
    >
    </app-link-list-item>
  </ng-container>
</app-block-wrapper>
